export const sheepLottie =
  "https://assets3.lottiefiles.com/private_files/lf30_lgesk2nm.json";
export const arrowDownLottie =
  "https://assets5.lottiefiles.com/packages/lf20_uxqdrvci.json";
